<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {WorkerKind} from "@/modules/redactor/models/worker/WorkerKind";

export default {
  name: "r-worker-kind",
  props: {
    model: VueTypes.instanceOf(WorkerKind),
    items: VueTypes.arrayOf(WorkerKind),
    label: VueTypes.string.def("Worker kind:"),
    skipNone: VueTypes.bool.def(false)
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      if (this.items && this.items.length > 0) {
        return this.items;
      } else if (this.skipNone) {
        return WorkerKind.getValues().filter(v => !WorkerKind.isNone(v));
      } else {
        return WorkerKind.getValues();
      }
    }
  }
}
</script>